<template>
  <div id="page-brand-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ brandsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : brandsData.length }} of {{ brandsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    v-model="searchQuery"
                    @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

<!--          <router-link-->
<!--            :to="{ path: '/brand/add' }"-->
<!--            v-if="$store.state.AppActiveUser.userInfo.roles[0].permissions.map(permission => permission.name).includes('create_brand')"-->
<!--          >-->
<!--            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">-->
<!--              <span class="mr-2 leading-none">Add</span>-->
<!--              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />-->
<!--            </div>-->
<!--          </router-link>-->
        <router-link
          :to="{ path: '/brand/add' }"
        >
          <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
            <span class="mr-2 leading-none">Add</span>
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          </div>
        </router-link>
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="brandsData.hotels"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleBrandManagement from '@/store/brand-management/moduleBrandManagement.js'

// Cell Renderer
import CellRendererLogo from './cell-renderer/CellRendererLogo.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'


export default {
  metaInfo: {
    title: "Brands",
    titleTemplate: "%s - Vancy Net",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLogo,
    CellRendererActions
  },
  data () {
    return {
      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        rowHeight: 100
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        wrapText: true,
        autoHeight: true,
      },
      columnDefs: [
        {
          headerName: 'City',
          field: 'city',
          width: 170
        },
        {
          headerName: 'Category Product',
          field: 'propertyTypeName',
          width: 150
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 300
        },
        {
          headerName: 'PHRI Code',
          field: 'phriCode',
          width: 150
        },
        {
          headerName: 'Active Provider',
          field: 'activeProvider',
          width: 100
        },
        {
          headerName: 'Vancynet Markup',
          field: 'vancynetMarkup',
          width: 100
        },
        {
          headerName: 'MG Markup',
          field: 'mgMarkup',
          width: 100
        },
        // {
        //   headerName: 'Logo',
        //   field: 'logo',
        //   cellRendererFramework: 'CellRendererLogo',
        //   width: 200,
        //   cellStyle () {
        //     return {'white-space': 'normal', 'line-height': 3}
        //   }
        // },
        {
          headerName: 'Actions',
          field: 'transactions',
          cellRendererFramework: 'CellRendererActions',
          cellRendererParams: {
            getData: this.getData.bind(this)
          },
          headerClass: "text-center",
          cellClass: "grid-cell-centered"
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLogo,
        CellRendererActions
      }
    }
  },

  computed: {
    brandsData () {
      return this.$store.state.brandManagement.brands
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },

    getData () {
      this.$vs.loading({
        type: 'sound'
      })

      this.$store.dispatch('brandManagement/fetchBrands')
                 // .catch(err => { this.$catchErrorResponse(err) })
                 .finally(res => {
                   this.$vs.loading.close()
                 })
    }
  },

  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridApi.sizeColumnsToFit();

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },

  created () {
    if (!moduleBrandManagement.isRegistered) {
      this.$store.registerModule('brandManagement', moduleBrandManagement)
      moduleBrandManagement.isRegistered = true
    }

    this.getData()
  }
}

</script>

<style lang="scss">
#page-brand-list {
  .brand-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.ag-row .ag-cell {
  display: flex;
  align-items: center;
}

.ag-row .text-right {
  flex-direction: row-reverse;
}

.ag-theme-material .ag-cell {
  line-height: 25px !important;
}

</style>
